/**
 * @module: company store
 * @author: xiongsha
 * @date: 2019-10-26 11:18:47
 */

import Task from './task';
import Project from './project';
import User from './user';
import ProjectCreation from './projectCreation';
import TaskCreate from './taskCreate';
import TaskEdit from './taskEdit';
import TaskDetailUI from './taskDetailUI';
import TaskDetail from './taskDetail';
import MyTaskUI from './myTaskUI';
import Check from './check';
import Modal from './modal';
import TaskProject from './taskProject';
import TaskOKR from './taskOKR';
import Trend from './trend';

export interface IMobxState {
  task: Task;
  project: Project;
  user: User;
  projectCreation: ProjectCreation;
  taskCreate: TaskCreate;
  taskEdit: TaskEdit;
  check: Check;
  modal: Modal;
  taskDetailUI: TaskDetailUI;
  taskDetail: TaskDetail;
  myTaskUI: MyTaskUI;
  taskProject: TaskProject;
  taskOKR: TaskOKR;
  trend: Trend;
}

const company = {
  task: new Task(),
  project: new Project(),
  user: new User(),
  projectCreation: new ProjectCreation(),
  taskCreate: new TaskCreate(),
  taskEdit: new TaskEdit(),
  check: new Check(),
  modal: new Modal(),
  taskDetailUI: new TaskDetailUI(),
  myTaskUI: new MyTaskUI(),
  taskProject: new TaskProject(),
  taskDetail: new TaskDetail(),
  taskOKR: new TaskOKR(),
  trend: new Trend()
};

export default company;
